import React, { useEffect } from 'react';
import { Modal, Form, Input, Button, message } from 'antd';
import { LockOutlined } from '@ant-design/icons';

const ChangePasswordDialog = ({ user, onSubmit, onCancel }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    // Reset form when user changes
    if (user) {
      form.resetFields();
    }
  }, [user, form]);

  const handleSubmit = async (values) => {
    try {
      await onSubmit({
        password: values.password,
        confirmPassword: values.confirmPassword,
        mustChangePassword: true,
        id: user.id
      });
      form.resetFields();
    } catch (error) {
      message.error('Failed to change password');
    }
  };

  // Password validation regex
  const passwordValidator = (_, value) => {
    if (!value) {
      return Promise.reject(new Error('Password is required'));
    }
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$&*])[A-Za-z\d!@#$&*]{8,12}$/;
    if (!passwordRegex.test(value)) {
      return Promise.reject(
        new Error('Password must be 8-12 characters with at least one uppercase, one lowercase, one number, and one special character (!@#$&*)')
      );
    }
    return Promise.resolve();
  };

  // Confirm password validator
  const confirmPasswordValidator = (_, value) => {
    if (!value) {
      return Promise.reject(new Error('Please confirm your password'));
    }
    if (value !== form.getFieldValue('password')) {
      return Promise.reject(new Error('Passwords do not match'));
    }
    return Promise.resolve();
  };

  return (
    <Modal
      title="Change Password"
      open={!!user}
      onCancel={onCancel}
      footer={null}
      width={500}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        autoComplete="off"
      >
        <Form.Item
          label="New Password"
          name="password"
          rules={[{ validator: passwordValidator }]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Enter new password"
            size="large"
          />
        </Form.Item>

        <Form.Item
          label="Confirm Password"
          name="confirmPassword"
          dependencies={['password']}
          rules={[{ validator: confirmPasswordValidator }]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Confirm new password"
            size="large"
          />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0, marginTop: 24 }}>
          <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
            <Button onClick={onCancel}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ChangePasswordDialog;
